import React from 'react';

export default function ToggleIcon() {
  return (
    <svg width="49px" height="49px" viewBox="0 0 49 49" version="1.1">
      <defs>
        <filter
          x="-38.7%"
          y="-38.7%"
          width="177.4%"
          height="177.4%"
          filterUnits="objectBoundingBox"
          id="filter-1"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="2"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.102627841 0"
            type="matrix"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-697.000000, -726.000000)">
          <g
            filter="url(#filter-1)"
            transform="translate(721.500000, 750.500000) rotate(-180.000000) translate(-721.500000, -750.500000) translate(706.000000, 735.000000)"
          >
            <circle cx="15.5" cy="15.5" r="15.5" />
            <path
              d="M16.3262273,13.2118001 L21.9340885,21.4366632 C22.2452109,21.8929759 22.1275108,22.515105 21.671198,22.8262273 C21.5051473,22.9394437 21.3088358,23 21.1078612,23 L9.89213881,23 C9.33985406,23 8.89213881,22.5522847 8.89213881,22 C8.89213881,21.7990254 8.95269509,21.6027139 9.06591147,21.4366632 L14.6737727,13.2118001 C14.984895,12.7554873 15.6070241,12.6377872 16.0633368,12.9489096 C16.1666295,13.0193364 16.2558005,13.1085074 16.3262273,13.2118001 Z"
              fill="#FFFFFF"
              transform="translate(15.500000, 17.500000) rotate(-180.000000) translate(-15.500000, -17.500000) "
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
